
export const loadJotFormScript = (callback?: () => void) => {
    const feedbackScriptId = 'jotform-feedback-script';
  
    if (!document.getElementById(feedbackScriptId)) {
      const feedbackScript = document.createElement('script');
      feedbackScript.src = 'https://form.jotform.com/static/feedback2.js';
      feedbackScript.type = 'text/javascript';
      feedbackScript.id = feedbackScriptId;
  
      feedbackScript.onload = () => {
        if (callback) callback(); 
      };
  
      document.body.appendChild(feedbackScript);
    } else {
      if (callback) callback();
    }
  };
  